import { render, staticRenderFns } from "./Bookshelf.vue?vue&type=template&id=47a200bc&scoped=true&"
import script from "./Bookshelf.vue?vue&type=script&lang=js&"
export * from "./Bookshelf.vue?vue&type=script&lang=js&"
import style0 from "./Bookshelf.vue?vue&type=style&index=0&id=47a200bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a200bc",
  null
  
)

export default component.exports